<div [ngClass]="loading ? 'blur-background' : ''" class="modal-body">
  <div *ngIf="loading" class="text-center position-absolute top-50 start-50 " style="z-index: 10000;">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div   class="row m-4" >

    <div class="col-md-12 text-start">
      <label for="publicKey" class="form-label" style="font-weight: bold">Customer
        Profile - {{customerNo}}</label>
      <div *ngIf="!isTableEmpty">
        <div class=" position-relative mt-5">
          <li>
            <label for="publicKey" class="form-label" style="font-weight: bold">Cash
              Accounts</label>
          </li>

          <div class="table-container mt-3">
            <table class="table table-sm">
              <thead>
              <tr>
                <th scope="col">Cash A/C type</th>
                <th scope="col">Cash A/C No</th>
                <th scope="col">Currency</th>

              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let cash of customerDetails?.['cashAccounts']">
                <td *ngIf="cash.accountType == 0">Current</td>
                <td *ngIf="cash.accountType == 1">Savings</td>
                <td *ngIf="cash.accountType == 2">Investment</td>
                <!-- <td *ngIf="cash.accountType == 3">Segregated</td> -->
                <td>{{cash.cashAccountNumber}}</td>
                <td>{{cash.currency}}</td>
                <td *ngIf="cash.status == 2">APPROVED</td>
                <td *ngIf="cash.status == 5">DELETE</td>
                <td *ngIf="cash.status != 2 && cash.status != 5">
                  UNKNOWN
                </td>

              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class=" position-relative mt-5">
          <li>
            <label for="publicKey" class="form-label" style="font-weight: bold">Security
              Accounts</label>
          </li>

          <div class="table-container mt-3">
            <table class="table table-sm">
              <thead>
              <tr>
                <th scope="col">Security A/C No</th>
                <th scope="col">Account Type</th>
                <th scope="col">Cash A/C No</th>
                <th scope="col">Status</th>

              </tr>
              </thead>
              <tbody *ngFor="let cash of customerDetails?.['cashAccounts']">
              <tr *ngFor="let security of cash?.['securityAccounts']">
                <td>{{security.accountNumber}}</td>
                <td *ngIf="security.type == 1">Equity</td>
                <td *ngIf="security.type == 2">Options</td>
                <td *ngIf="security.type == 3">Futures</td>
                <td *ngIf="security.type == 4">Forex</td>
                <td *ngIf="security.type == 5">CFD</td>
                <td *ngIf="security.type == 6">Spot</td>
                <td *ngIf="security.type == 7">Auto Trade</td>
                <td *ngIf="security.type == 8">Investment</td>
                <td *ngIf="security.type == 9">Fixed Income</td>
                <!--                          <td *ngIf="security.type == 10">crypto</td>-->
                <!--                          <td *ngIf="security.type == 11 ">-->
                <!--                            Investor Portfolio-->
                <!--                          </td>-->

                <td>{{cash.cashAccountNumber}}</td>
                <td *ngIf="security.statusId == 2">APPROVED</td>
                <td *ngIf="security.statusId == 5">DELETE</td>
                <td *ngIf="security.statusId != 2 && security.statusId != 5">
                  UNKNOWN
                </td>

              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class=" position-relative mt-5">
          <li>
            <label for="publicKey" class="form-label" style="font-weight: bold">Exchange
              Accounts</label>
          </li>

          <div class="table-container mt-3">
            <table class="table table-sm">
              <thead>
              <tr>

                <th scope="col">Exchange A/C No</th>
                <th scope="col">Security A/C No</th>
                <th scope="col">Exchange</th>


              </tr>
              </thead>
              <ng-container *ngFor="let cash of customerDetails?.['cashAccounts']">
                <tbody *ngFor="let security of cash?.['securityAccounts']">
                <tr *ngFor="let exchange of security?.['exchangeAccounts']">


                  <td >{{exchange.exchangeAccountId}}</td>

                  <td
                    *ngIf="exchange.tradingEnabled != 0 && exchange.tradingEnabled != 1 ">
                    null
                  </td>

                  <td>
                    {{security.accountNumber}}
                  </td>
                  <td>{{exchange.exchange}}</td>





                </tr>
                </tbody>
              </ng-container>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modalRef.close()">
    Close
  </button>
</div>

